<template>
    <div class="bg-white p-3 h-100 m-2" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
        {{ title }}
        <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm rounded-circle">
            <span class="tooltip-text">در صورتی که شبای مقصد از بانکهای فعال باشد، واریز داخلی (آنی) و در غیر این صورت، واریز پایا انجام میگردد.</span>
            <i class="fas fa-info-circle"></i>
        </span>
        <span v-for="(value, name, index) in has_settlement_token"  :key="index" class="px-3">
                <i class="fa px-1" :class="value.is_active ? 'fa-check text-success' : 'fa-times text-danger'"></i>
                {{ $t(`wallets.bank.${name}`) }}
        </span>
    </div>
</template>

<script>
    import {walletService} from "@/common/api.service";

    export default {
        name: "active-token",
        props: {
            title: {
                default() {
                    return {}
                }
            },
        },
        data() {
            return {
                has_settlement_token: []
            }
        },

        mounted() {
            walletService.getActiveBanks().then(res => {
                this.has_settlement_token = res.data.data;
            });
        },
    }
</script>
